import "./UserProfile.scss";

import chevronLeft from "../../assets/images/icons/chevron-left.svg";
import upload from "../../assets/images/icons/upload.svg";

import axios from "axios";

import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import UserFavoriteEvents from "../../components/UserFavoriteEvents/UserFavoriteEvents";
import UserPastEvents from "../../components/UserPastEvents/UserPastEvents";
import UserFollowing from "../../components/UserFollowing/UserFollowing";

function UserProfile() {
    const { userID } = useParams();
    const [userInfo, setUserInfo] = useState([]);
    const [userPhoto, setUserPhoto] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        const getUser = async () => {
            try {
                const response = await axios.get(`https://zona-app-server-584d567d8841.herokuapp.com/users/${userID}`);
                setUserPhoto(`data:image/jpeg;base64,${response.data.photo}`);
                setUserInfo(response.data);
            } catch (err) {
                console.log(`error fetching user. this is the error: ${err}`);
            }
        };
        getUser();
    }, [userID]);

    //SUB NAV ====================================================================

    const [favoriteEventsActive, setFavoriteEventsActive] = useState(true);
    const [pastEventsActive, setPastEventsActive] = useState(false);
    const [followingActive, setFollowingActive] = useState(false);

    function handleSubNavClick(tab) {
        switch (tab) {
            case "favEvents":
                setPastEventsActive(false);
                setFollowingActive(false);
                setFavoriteEventsActive(true);
                break;
            case "pastEvents":
                setFollowingActive(false);
                setFavoriteEventsActive(false);
                setPastEventsActive(true);
                break;
            case "following":
                setFavoriteEventsActive(false);
                setPastEventsActive(false);
                setFollowingActive(true);
                break;
            default:
                break;
        }
    }

    return (
        <main>
            <section className="user-profile">
                <div className="user-profile__top">
                    <div className="user-profile__top-left">
                        <img
                            src={chevronLeft}
                            onClick={() => navigate(-1)}
                            className="user-profile__top-left-icon"
                            alt="arrow head poining left"
                        ></img>
                        <h1 className="user-profile__top-left-heading">User Profile</h1>
                    </div>

                    <button className="user-profile__top-clear">
                        Export data
                        <img src={upload} className="user-profile__top-clear-icon" alt="export here"></img>
                    </button>
                </div>

                <section className="user-profile__user">
                    <div style={{ backgroundImage: `url(${userPhoto})` }} className="user-profile__user-avatar"></div>
                    {/* <img src={`data:image/jpeg;base64,${userInfo.photo}`} className='user-profile__user-avatar' alt={`${userInfo.firstName} ${userInfo.lastName} avatar`}></img> */}

                    <div className="user-profile__user-writing">
                        <h2 className="user-profile__user-writing-heading">
                            {userInfo?.firstName} {userInfo?.lastName}
                        </h2>
                        <p className="user-profile__user-writing-text">age, location</p>
                        <p className="user-profile__user-writing-text">ig handle</p>
                    </div>
                </section>

                <section className="user-profile__tabs">
                    <div
                        onClick={() => handleSubNavClick("favEvents")}
                        className={
                            favoriteEventsActive
                                ? "user-profile__tabs-tab user-profile__tabs-tab--active"
                                : "user-profile__tabs-tab"
                        }
                    >
                        Favorite Events
                    </div>
                    <div
                        onClick={() => handleSubNavClick("pastEvents")}
                        className={
                            pastEventsActive
                                ? "user-profile__tabs-tab user-profile__tabs-tab--active"
                                : "user-profile__tabs-tab"
                        }
                    >
                        Past Events
                    </div>
                    <div
                        onClick={() => handleSubNavClick("following")}
                        className={
                            followingActive
                                ? "user-profile__tabs-tab user-profile__tabs-tab--active"
                                : "user-profile__tabs-tab"
                        }
                    >
                        Following
                    </div>
                </section>

                {favoriteEventsActive && <UserFavoriteEvents />}
                {pastEventsActive && <UserPastEvents />}
                {followingActive && <UserFollowing />}
            </section>
        </main>
    );
}

export default UserProfile;
